/* RestEase: smooth scrolling with Lenis (assets/lenis.min.js).
   - Off in the theme editor, for visitors who prefer reduced motion,
     and on touch devices (native touch scrolling is kept).
   - Pauses automatically while a drawer, modal or popup locks the page.
   - Add data-lenis-prevent to any element that should scroll natively
     (e.g. a scrollable list inside a popup). */
(function () {
  if (!window.Lenis) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;

  function headerOffset() {
    var h = document.querySelector('.site-header, header');
    if (!h) return 0;
    var pos = window.getComputedStyle(h).position;
    return (pos === 'sticky' || pos === 'fixed') ? h.offsetHeight + 16 : 16;
  }

  var lenis = new Lenis({
    autoRaf: true,
    lerp: 0.1,
    wheelMultiplier: 1,
    smoothWheel: true,
    syncTouch: false,
    anchors: { offset: -headerOffset() },
    prevent: function (node) {
      return !!(node && node.closest && node.closest(
        '[data-lenis-prevent], [role="dialog"], [aria-modal="true"], .drawer, .cart-drawer, .modal, .popup, .mega-menu, .menu-drawer, select, textarea'
      ));
    }
  });
  window.lenis = lenis;

  /* Pause while something locks page scroll. The theme adds "m:overflow-hidden"
     to <html>/<body> for drawers and popups; apps set inline overflow:hidden. */
  var LOCK_CLASS = /(^|\s)(m:overflow-hidden|overflow-hidden|scroll-lock|no-scroll|modal-open|drawer-open)(\s|$)/;
  function lockedEl(el) {
    if (!el) return false;
    if (LOCK_CLASS.test(el.className || '')) return true;
    var st = el.style;
    return st.overflow === 'hidden' || st.overflowY === 'hidden' || st.position === 'fixed';
  }
  function isLocked() {
    return lockedEl(root) || lockedEl(document.body);
  }
  var paused = false;
  function sync() {
    var locked = isLocked();
    if (locked && !paused) { lenis.stop(); paused = true; }
    else if (!locked && paused) { lenis.start(); paused = false; }
  }
  var mo = new MutationObserver(sync);
  function observe() {
    mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    mo.observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
    sync();
  }
  if (document.body) observe(); else document.addEventListener('DOMContentLoaded', observe);

  /* Keep anchor offset right if the header height changes (resize, announcement bar closed). */
  window.addEventListener('resize', function () {
    if (lenis.options && lenis.options.anchors) lenis.options.anchors = { offset: -headerOffset() };
  });
})();
